import {
  FilterType,
  buildProjectTasksDataTableFilter,
  useProjectTasksDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { taskStatuses } from 'modules/tasks/lib/status'

const options = () =>
  taskStatuses().map((status) => ({ label: status.title, value: status.status }))

export const statusFilter = (source: ReturnType<typeof useProjectTasksDataTable>) =>
  buildProjectTasksDataTableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options: options(),
      },
    ],
    identifier: 'projectTaskList.statusFilter',
    path: 'status',
    title: i18n.t('tasks.filter.status'),
  })
